/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import { DocumentValueType } from '../Types/CommonTypes';

export interface IValidateDocumentRequest extends DocumentValueType {
  recaptcha?: {
    responseToken?: string;
  };
}

const definitions = Definitions.ValidateDocument;

const callPost = async (
  params: IValidateDocumentRequest,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };
export default { call, definitions };
